
export enum RPCPublishmentName {
  FetchRequestStarted = 'fetch.onRequestStarted',
  // FetchRequestSucceeded = 'fetch.onRequestSucceeded',
  // FetchRequestFailed = 'fetch.onRequestFailed',
  FetchMetadataUpdated = 'fetch.onRequestMetadataUpdated',
  InjectHotKeyPressed = 'inject.HotKeyPressed',
}



/**
 * Pub-sub publish
 */
 export interface IRPCPublishment {
  publishmentName: string
  message: any
}

